export const NEW_MSG = 'new_msg';
export const ACK_MSG = 'ack_msg';
export const UPDATE_CHANNEL_TITLE = 'update_channel_title';
export const NEW_CHANNEL_MEMBER = 'new_channel_member';
export const DELETE_CHANNEL_MEMBER = 'delete_channel_member';
export const ERROR = 'error';
export const AUTHENTICATION = 'authentication';
export const UNAUTHENTICATED = 'unauthorized';
export const AUTHENTICATED = 'authenticated';



// WEBPACK FOOTER //
// ./src/constants/WebsocketEventTypes.js